import i18n from "i18n";

// Le etichette sono lette al momento dell'uso (getter), cosi' seguono la lingua corrente.
const coded = (code, key) => ({
  code,
  get label() {
    return i18n.t(key);
  },
});

// Categorie del Dataset Bevande: il codice corrisponde a quello del backend.
export const BEVERAGE_SECTIONS = [
  coded("beer", "common:beverageSections.beer"),
  coded("beverages", "common:beverageSections.beverages"),
  coded("waters", "common:beverageSections.waters"),
  coded("drinks", "common:beverageSections.drinks"),
  coded("spirits", "common:beverageSections.spirits"),
  coded("mixers", "common:beverageSections.mixers"),
];

export const sectionLabel = (code) =>
  BEVERAGE_SECTIONS.find((s) => s.code === code)?.label || code;

// Allergeni UE (codici accettati dal backend).
export const ALLERGENS = [
  coded("gluten", "common:allergens.gluten"),
  coded("crustaceans", "common:allergens.crustaceans"),
  coded("eggs", "common:allergens.eggs"),
  coded("fish", "common:allergens.fish"),
  coded("peanuts", "common:allergens.peanuts"),
  coded("soy", "common:allergens.soy"),
  coded("milk", "common:allergens.milk"),
  coded("nuts", "common:allergens.nuts"),
  coded("celery", "common:allergens.celery"),
  coded("mustard", "common:allergens.mustard"),
  coded("sesame", "common:allergens.sesame"),
  coded("sulphites", "common:allergens.sulphites"),
  coded("lupin", "common:allergens.lupin"),
  coded("molluscs", "common:allergens.molluscs"),
];

export const BEVERAGE_IMAGE_FIELDS = [
  {
    name: "front_bottle_image",
    get label() {
      return i18n.t("common:beverageImages.frontBottle");
    },
  },
  {
    name: "back_bottle_image",
    get label() {
      return i18n.t("common:beverageImages.backBottle");
    },
  },
  {
    name: "front_label_image",
    get label() {
      return i18n.t("common:beverageImages.frontLabel");
    },
  },
  {
    name: "back_label_image",
    get label() {
      return i18n.t("common:beverageImages.backLabel");
    },
  },
  {
    name: "pairing_image",
    get label() {
      return i18n.t("common:beverageImages.pairing");
    },
  },
];
